function _(n,t,i){t.exports=n(19)()?Math.sign:n(20)}
//# sourceMappingURL=index.min.js.map